import { Input, Form, Flex } from 'antd'
import { FC } from 'react'
import '../styles/CharacteristicInput.scss'

interface CharacteristicInputProps {
	label: string
	measurement?: string
	placeholder?: string
	fieldName: string
	required?: boolean
	requiredMessage?: string
}

export const CharacteristicInput: FC<CharacteristicInputProps> = ({
	label,
	measurement,
	placeholder,
	fieldName,
	required = false,
	requiredMessage = 'Это поле обязательно'
}) => {
	return (
		<Form.Item
			label={label}
			name={fieldName}
			rules={[
				{
					required,
					message: requiredMessage
				}
			]}
			className="characteristic-form-item">
			<Flex
				gap={12}
				align="center"
				className="characteristic-input-wrapper">
				<Input
					placeholder={placeholder}
					className="characteristic-input-field"
				/>
				{measurement && (
					<span className="characteristic-measurement">
						{measurement}
					</span>
				)}
			</Flex>
		</Form.Item>
	)
}
